import { Injectable } from '@angular/core';
import { onFCP, onLCP, onCLS } from 'web-vitals';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class WebVitalsService {

  metrics: any = {
    FCP: 0,
    LCP: 0,
    CLS: 0,
    TBT: 0
  };

  constructor() {
    this.initVitals();
    this.observeLongTasks();
  }

  private sendToGA(name: string, value: number) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, {
        value: Math.round(name === 'CLS' ? value * 1000 : value),
        metric_id: name,
        metric_value: value,
        metric_delta: value,
        non_interaction: true
      });
    }
  }

  private initVitals() {

    onFCP((metric) => {
      this.metrics.FCP = metric.value;
    });

    onLCP((metric) => {
      this.metrics.LCP = metric.value;
    });

    onCLS((metric) => {
      this.metrics.CLS = metric.value;
    });
  }

  // Manual TBT calculation
  private observeLongTasks() {
    let totalBlockingTime = 0;

    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry: any) => {
          const blockingTime = entry.duration - 50;
          if (blockingTime > 0) {
            this.metrics.TBT += blockingTime;
          }
        });
      });

      observer.observe({ type: 'longtask', buffered: true });
       // Send TBT after page load stabilizes
      window.addEventListener('load', () => {
        setTimeout(() => {
          this.sendToGA('TBT', totalBlockingTime);
        }, 0);
      });
    }
  }

  getMetrics() {
    return this.metrics;
  }
}